import React, { Component } from 'react';
import config from 'react-global-configuration';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class SchedulesElaborateExpirations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      month: this.props.month,
      year: this.props.year,
      certifications_id: [],
      aircraft_model_id: this.props.aircraft_model_id,
      schedule: this.props.schedule,
      certifications_list: this.props.certifications_list,
      linha: 'undefined',
      colunas: {},
      certification_ids: [],
      view_table: 0,
    };
    this.elaborate = this.elaborate.bind(this);

    this.locale = getLocale();
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && newProps.show !== 0)) {
      this.setState({
        month: newProps.month,
        year: newProps.year,
        aircraft_model_id: newProps.aircraft_model_id,
        certifications_list: newProps.certifications_list,
        schedule: newProps.schedule,
        show: newProps.show,
        loaded: 1,
      });
    } else if(newProps.show === 0){
      this.setState({
        view_table: 0,
        loaded: 0,
        show: 0,
        linha: [],
        colunas: [],
        schedule: [],
      });

    }
  }

  elaborate(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      month: this.state.month,
      year: this.state.year,
      aircraft_model_id: this.state.aircraft_model_id,
      certifications_id: this.state.certifications_id,
      action: 4,
    };

    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/elaboracao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
         self.setState({schedule: responseJson.schedule});
         self.setState({linha: responseJson.data});
         self.setState({colunas: responseJson.colunas});
         self.setState({view_table: 1});
        }
        self.props.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  render() {
    var self = this;
    return (
<div>
  {(self.state.show === 1) ? 
    <div>
      <h3>{this.locale.Escalas.ElaboracaoDeEscala.tituloElaboracaoDeEscalaVencimentos} <small> - {self.state.schedule['name'] + ' - ' + self.state.schedule['aircraft_model']['model']}</small></h3>
      <hr/>
      <form onSubmit={this.elaborate}>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>{this.locale.Escalas.ElaboracaoDeEscala.formularioElaboracaoDeEscalaVencimentos.Certificados}:</label>
              <Select
                className=""
                name="certifications_id"
                value={this.state.certifications_id}
                searchable={true}
                multi={true}
                placeholder={this.locale.Escalas.ElaboracaoDeEscala.formularioElaboracaoDeEscalaVencimentos.placeholder.SelecionarCertificados}
                onChange={this.handleSelectChange.bind(this, 'certifications_id')}
                options={this.state.certifications_list}
              />
            </div>
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.buscar}</button>
        {(self.state.view_table == 1) ? 
          <div className="listing table-responsive">
            <hr/>
            <table className="table table-bordered table-striped table-hover">
                <thead>
                    <tr>
                        <th>{this.locale.Escalas.ElaboracaoDeEscala.formularioElaboracaoDeEscalaVencimentos.tabela.Matricula}</th>
                        <th>{this.locale.Escalas.ElaboracaoDeEscala.formularioElaboracaoDeEscalaVencimentos.tabela.NomeDeGuerra}</th>
                        <th>{this.locale.Escalas.ElaboracaoDeEscala.formularioElaboracaoDeEscalaVencimentos.tabela.CHTFrota}</th>
                        <th>{this.locale.Escalas.ElaboracaoDeEscala.formularioElaboracaoDeEscalaVencimentos.tabela.CCF}</th>
                        <th>{this.locale.Escalas.ElaboracaoDeEscala.formularioElaboracaoDeEscalaVencimentos.tabela.TotalHoras}</th>
                        <th>{this.locale.Escalas.ElaboracaoDeEscala.formularioElaboracaoDeEscalaVencimentos.tabela.VencimentoNoturno}</th>
                        {Object.keys(self.state.colunas).map(function(c) {
                          return (
                            <th>{self.state.colunas[c]}</th>
                          );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(self.state.linha).map(function(l) {
                      return (
                        <tr>
                            <td>{self.state.linha[l]['matricula']}</td>
                            <td>{self.state.linha[l]['nickname']}</td>
                            <td dangerouslySetInnerHTML={{__html: self.state.linha[l]['cht']}}></td>
                            <td dangerouslySetInnerHTML={{__html: self.state.linha[l]['ccf']}}></td>
                            <td>{self.state.linha[l]['total_h']}</td>
                            <td>{self.state.linha[l]['noturno']}</td>
                            {Object.keys(self.state.colunas).map(function(c) {
                              return (
                                <td dangerouslySetInnerHTML={{__html: self.state.linha[l][self.state.colunas[c]]}}></td>
                              );
                            })}
                        </tr>
                      );
                    })}
                </tbody>
            </table>
          </div>
          : ''
        }
      </form>
    </div>
    : ''
  }
</div>
    );
  }
}

export default SchedulesElaborateExpirations;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/SchedulesElaborateExpirations.js